import { Typography } from '@mui/material'
import tw from 'twin.macro'
import React, { ReactNode } from 'react'

export interface BasicModalDescriptionInterface {
  title: string
  icon: ReactNode
  description: string
  className?: any
}

export const BasicModalDescription = ({
  title,
  icon,
  description,
  className,
}: BasicModalDescriptionInterface) => {
  return (
    <div css={[tw`p-4 pb-0 flex flex-col items-start`, className]}>
      <div css={tw`flex items-center w-full`}>
        <div css={tw`mr-4 w-5 h-5 text-black flex items-center justify-center`}>{icon}</div>
        <div>
          <Typography variant="h5" css={tw`text-base font-bold`}>
            {title}
          </Typography>
          <Typography variant="body2" css={tw`text-[#847E96] text-sm`}>
            {description}
          </Typography>
        </div>
      </div>
    </div>
  )
}
